;(function () {
  if (typeof window === `undefined` || typeof navigator === `undefined`) return false

  if (
    /iPhone/i.test(navigator.userAgent || navigator.vendor || (window.opera && opera.toString() === `[object Opera]`))
  )
    document.body.classList.add('iAmiPhone')

  if (
    /Mac OS X/i.test(navigator.userAgent || navigator.vendor || (window.opera && opera.toString() === `[object Opera]`))
  )
    document.body.classList.add('iAmMac')
})()

if (typeof ThumbnailGallery !== 'function') {
  class ThumbnailGallery extends HTMLElement {
    constructor() {
      super()
      this.swiper = this.querySelector('.swiper')
      this.thumbnailHashs = this.querySelectorAll('.thumbnailHash')
      this.featuredMediaHash = [...this.thumbnailHashs].find((e) => e.dataset.featured === 'true')
      this.settings = {
        loop: true,
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        },
        on: {
          activeIndexChange: (swiper) => {
            this.update(swiper)
          },
          init: (swiper) => {
            this.update(swiper)
          },
        },
        spaceBetween: 30,
      }
      this.swipper

      this.init()
      document.addEventListener('shopify:section:load', (event) => {
        this.init()
      })

      /* window.addEventListener('resize', (event) => {
        this.init();
      }); */

      Array.from(this.thumbnailHashs).forEach((thumbnailHash) =>
        thumbnailHash.addEventListener('click', () => this.thumbnailhandle(thumbnailHash))
      )
    }
    init() {
      if (typeof Swiper !== 'function') {
        document.addEventListener('swiper:loaded', (e) => {
          this.settings.modules = [Swiper.Navigation, Swiper.Pagination]
          this.initSlider()
        })
      } else {
        this.settings.modules = [Swiper.Navigation, Swiper.Pagination]
        this.initSlider()
      }
    }
    initSlider() {
      if (this.swipper && this.swipper.destroy) {
        this.swipper.destroy()
        this.swipper = null

        this.swipper = new Swiper(this.swiper, this.settings)
      } else {
        this.swipper = new Swiper(this.swiper, this.settings)
      }

      if (this.featuredMediaHash) {
        this.setActiveMedia(this.featuredMediaHash.id)
      }

      if (window.innerWidth < 768 && this.dataset.disableMobileSlider === 'true') {
        this.swipper.destroy()
        this.swipper = null
      }
    }
    thumbnailhandle(thumb) {
      if (this.swipper) {
        this.swipper.slideTo([...thumb.parentElement.children].indexOf(thumb) + 1)
      }
    }
    setActiveMedia(id) {
      if (this.swipper) {
        const hashFound = [...this.thumbnailHashs].find((thumbnailHash) => thumbnailHash.id === id)
        if (hashFound) {
          this.swipper.slideTo([...this.thumbnailHashs].indexOf(hashFound) + 1)
        }
      }
    }
    update(slider) {
      if (this.querySelector('.thumbnailHash.activeHash'))
        this.querySelector('.thumbnailHash.activeHash').classList.remove('activeHash')
      // this.thumbnailHashs[slider.realIndex].classList.add("activeHash")

      /* this.querySelector('.thumbnailsContainer').scrollTo({
        left: this.thumbnailHashs[slider.realIndex].offsetLeft - this.querySelector('.thumbnailsContainer').offsetLeft,
        behavior: "smooth"
      }) */
    }
  }

  customElements.define('thumbnail-gallery', ThumbnailGallery)
}
if (typeof CollectionsFilters !== 'function') {
  class CollectionsFilters extends HTMLElement {
    constructor() {
      super()
      this.init()
      this.filterLinks = this.querySelectorAll('.filter_box a')
      document.addEventListener('shopify:section:load', (event) => {
        this.init()
      })

      Array.from(this.filterLinks).forEach((link) => link.addEventListener('click', (e) => this.update(e)))
      this.initialOrder = JSON.parse(this.dataset.initialOrder)
      this.hideTitles = JSON.parse(this.dataset.hideTitles)
    }
    init() {
      this.update()
    }
    async update(e) {
      const link = e ? e.target : this.querySelector('.filter_box a.active')
      if (!link) return
      link.closest('.filter_box').querySelector('.active').classList.remove('active')
      link.classList.add('active')

      const url = `${window.Shopify.routes.root}collections/${link.dataset.handle}.json`
      const req = await fetch(url)
      const res = await req.json()

      this.selectedCollection = link.dataset.handle
      const selectedIndex = this.initialOrder.indexOf(link.dataset.handle)
      const titlesShouldBeHidden = this.hideTitles[selectedIndex]
      if (titlesShouldBeHidden) {
        ;[...document.querySelectorAll('.collection .heading_h2_text')].forEach((e) => e.classList.add('hide'))
      } else {
        ;[...document.querySelectorAll('.collection .heading_h2_text')].forEach((e) => e.classList.remove('hide'))
      }
      this.moveSelectedItemToFront()
      ;[...this.querySelectorAll('[data-collection-text]')].forEach((el) => el.classList.add('hide'))
      this.querySelector(`[data-collection-text=${this.selectedCollection}]`)?.classList.remove('hide')
      this.querySelector('.collectionsHeader .heading_h3').innerHTML = res.collection.description
    }
    /**
     * Move selected item to first position in collection list
     */
    moveSelectedItemToFront() {
      const collectionBoxes = [...document.querySelectorAll('.collection_box')]
      const selectedHandle = this.selectedCollection
      const parentNode = collectionBoxes[0].parentNode
      // detachAll
      // collectionBoxes.forEach(box => box.detach());
      // sort based on the handles in this.initialOrder
      collectionBoxes.sort((a, b) => {
        const aIndex = this.initialOrder.indexOf(a.dataset.collectionHandle)
        const bIndex = this.initialOrder.indexOf(b.dataset.collectionHandle)
        return bIndex - aIndex
      })

      collectionBoxes
        .filter((box) => box.dataset.collectionHandle != selectedHandle)
        .forEach((box) => parentNode.prepend(box))
      collectionBoxes
        .find((box) => box.dataset.collectionHandle === selectedHandle)
        ?.parentNode.prepend(collectionBoxes.find((box) => box.dataset.collectionHandle === selectedHandle))
    }
  }

  customElements.define('collections-filters', CollectionsFilters)
}

const griditemButtons = document.querySelectorAll('.griditem_product-context .button')
Array.from(griditemButtons).forEach((griditemButton) => {
  griditemButton.addEventListener('click', function () {
    if (griditemButton.closest('.productgrid').querySelector('.add_btn'))
      griditemButton.closest('.productgrid').querySelector('.add_btn').click()
  })
})

var links = document.links
var linksLength = links.length
for (let i = 0; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname && links[i].hostname !== '') {
    links[i].target = '_blank'
    links[i].rel = 'noreferrer noopener'
  }
}
